import React, { useContext, useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import "react-toggle/style.css"
import { useTranslation } from 'react-i18next';
import SimpleReactValidator from 'simple-react-validator';
import ButtonField from '../components/UI/Button/ButtonField';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import moment from 'moment';
import { isEmpty } from "components/Login/validator";
import 'assets/css/custom.css';
import { loopBackDomain, loopBackPort } from "environment/environment";
import { PostAPI } from "api/post";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner"; 
import { Collapse } from 'antd'
import { childList,ChildInfo,tp_info,level1_info,Level1_Details,Level8_Details,trace_info, ProductDetails,finalQcHeader,product_data,Dispatch,TP,Weight_Validation_Status,Pairing_Info,functionalTestingHeader,visualTestingHeader,Customer_registration,Warranty_return,Warranty_return_update,tp_attributes,transitInfo} from "constants/staticVariables";
import globaldata from "../constants/globaldata.json";
import { handleNetworkErrors } from "../utilities/CommonUtils.js";


const { Panel } = Collapse;



const cookies = new Cookies();
// import CardWallet from '../components/UI/CardWallet/CardWallet';


const Role = props => {
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? globaldata.unDefined : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState(globaldata.unDefined);
  const [validator] = useState(new SimpleReactValidator());
  const headerCounterArray = [];
  const { t, i18n } = useTranslation();
  let mapToProductDetials = {
    'Product Grade':'product_grade',
    'Product Status':'product_status',
    'Customer Status':'customer_status',
    'PO Number':'po_number',
    'Assigned PO':'Assined_po_number',
    'Warranty Period':"warranty_period",
    'Packed PO':'Packed_po_number'
  }
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
  });
  const divRef = React.useRef()
  let [disabledButton, setDisabledButton] = useState({
    isIotInspect: false,
    istrackIot: false,
    isbulkIotInspect: false
    });
  let [filteredCondition, setFilteredCondition] = useState(false)
  const [showFilter, setshowFilter] = useState(false);
  const [isShowClear, setIsShowClear] = useState({
    isIotInspect: false,
    istrackIot: false,
    isbulkIotInspect: false
  });
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [inspectValue, setInspectValue] = useState('');
  let [iotInspectData, setIotInspectData] = useState()
  let [showInspectData, setShowInspectData] = useState(false);
  let [inspectData, setInspectData] = useState({})
  let [showInspectLoadingSpinner, setShowInspectLoadingSpinner] = useState(false);
  let [showTrackIOTInspectLoadingSpinner, setShowTrackIOTInspectLoadingSpinner] = useState(false);


  const onChange = (key) => {
    console.log(key);
  };

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'languages.en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  let [columns, setColumns] = useState([
    {
      dataField: "dataFields.serialNo",
      text: "texts.serialNo"
    },
    {
      dataField: "dataFields.roleName",
      text: "texts.roleName"
    },
    {
      dataField: "dataFields.customerName",
      text: "texts.customerName"
    }
  ]);

  const columnsModified = columns.map((item) => {
    if (item.dataField !== 'dataFields.template') {
      return {
        ...item, formatter: (cell) => {
          if (cell == "NULL")
            return ""
          else
            return cell
        }
      }
    } else {
      return {
        ...item, formatter: (col, row) => {
          return <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{col}</span>
        }
      }
    }
  });

  let [formValue, setformValue] = useState();
  let [values, setValues] = useState();
  let [FilterformValues, setFilterformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  let [localSearch, setLocalSearch] = useState(false);
  let [productsDataChild, setproductsDataChild] = useState([]);
  let [timelineData, setTimelineData] = useState({});
  const [direction, setDirection] = useState("vertical");
  //let [modalTitle, setModalTitle] = useState();
  let [timelineTitle, setTimelineTitle] = useState();
  const [showTPModal, setshowTPModal] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  const [isCollapse, setIsCollapse] = useState(false)
  const [isLoader, setIsLoader] = useState(false)
  const language = currentLanguageCode === 'en' ? 'languages.en' : 'languages.chi'

  let dynamicParameters = {
    user_id: cookies.get(globaldata.userId),
    customer_id: cookies.get(globaldata.customerId),
    userLocation_id: cookies.get(globaldata.userLocationId),
    userRole_name: cookies.get(globaldata.userRoleName),
    language: language
  }


  const formElementsArray = [];
  for (let key in pageLayoutData[0].formValues) {
    formElementsArray.push({
      id: key,
      config: pageLayoutData[0].formValues[key]

    });
  }


  let productDetails = {}
  let pairing_info = {}
  let tp = {}
  let levelDetails = {}
  let level8Details = {}
  let UiiSiiDetails = {}
  let purchaseOrderDetails = {}
  let dispatchDetails = {}
  let childListDetails = {}
  let functionalTesting ={}
  let visualTesting ={}
  let weight_validationStatus = {}
  let final_qc ={}
  let purchaseOrderPacking = {}
  let pdi_inspect = {}
  let dispatch = {}
  let grn = {}
  let grade_change = {}
  let traceData=[]
  let tpAttributes = []
  let transitInformation = {}


  const excludingEmptyValues = (inspectedArray) => {
    let inspectedData;
     if(Array.isArray(inspectedArray)){
      inspectedData = inspectedArray.filter((item) =>  item && (Object.hasOwn(item, 'value') ? item.value : item))
    }else{
      Object.keys(inspectedArray).forEach((el) => {
        if(!inspectedArray[el]){
          delete inspectedArray[el]
        }
        })
          if(Object.hasOwn(inspectedArray, 'attributes')){
            inspectedArray.attributes = inspectedArray.attributes.filter((item) => item.value)
          }
          return inspectedArray

    }
    return inspectedData
  }


  for (let key in inspectData) {
   try{
    if(key === childList){
      if(inspectData[key].length!=0){
        let childIots= inspectData[key].map(e => e.primary_id)
        let childListIotData = excludingEmptyValues(childIots)
        childListDetails = { header: ChildInfo, conetent: childListIotData,parent:key }
      }
    
    }

    if(key === 'weight'){
      let weight_validationStatus_info = excludingEmptyValues(inspectData[key])
      weight_validationStatus = {header: Weight_Validation_Status, conetent: weight_validationStatus_info,parent:key }
    }
    if(key === 'pairing_info'){
      let UpdatedPairingInfo = excludingEmptyValues(inspectData[key])
      pairing_info = {header: Pairing_Info, conetent: UpdatedPairingInfo ,parent:key }
    }
    if (key === tp_info) {
      let Tp_Info = excludingEmptyValues(inspectData[key])
      tp = { header: TP, conetent: Tp_Info,parent:key }
    }
    if (key === level1_info) {
      const rows = inspectData[key].length
      let levelDetailsInfo = excludingEmptyValues(inspectData[key])
      for( let i=0; i<rows; i++){
        if(inspectData[key][i].name === 'level'){
          switch(parseInt(inspectData[key][i].value)){
            case 8:
              level8Details = { header: Level8_Details, conetent: levelDetailsInfo,parent:key }
            break;
            default:
              levelDetails = { header: Level1_Details, conetent: levelDetailsInfo,parent:key }
          }
        }
      }
    }
    if (key === trace_info) {
      const rows = inspectData[key].length
      for(let i=0;i<rows;i++){
        if(inspectData[key][i].status === 'Purchase order packing'){
          let purchaseOrderPacking_info = excludingEmptyValues(inspectData[key][i])
          purchaseOrderPacking = { header: inspectData[key][i].status,
             conetent: purchaseOrderPacking_info,
              parent:key}
        }
        if(inspectData[key][i].status ==='PDI Inspect'){
          let pdiInspect_info = excludingEmptyValues(inspectData[key][i])
          pdi_inspect = { header: inspectData[key][i].status,
             conetent: pdiInspect_info,
             parent:key}
        }
        if(inspectData[key][i].status ==='Dispatch'){
          let dispatch_info = excludingEmptyValues(inspectData[key][i])
          dispatch = { header: inspectData[key][i].status,
             conetent: dispatch_info,
             parent:key}
        }
        // if(inspectData[key][i].status ==='GRN'){
        //   // console.log("@vachina",inspectData[key][i])
        //   let grnData_info = excludingEmptyValues(inspectData[key][i])
        //   grn = { header: inspectData[key][i].status, 
        //     conetent: inspectData[key][i],
        //     parent:key}
        // }
        // if(inspectData[key][i].status === 'Grade Change'){
        //   grade_change = {header: inspectData[key][i].status,
        //     conetent: inspectData[key][i],
        //     parent:key

        //   }
        // }
      }
        inspectData[key].map(e => {
          if(e.status !== 'Purchase order packing' && e.status !== 'Dispatch' && e.status !== 'PDI Inspect'){
            let traceData_info = excludingEmptyValues(e)
          traceData.push({ header: e.status, conetent: traceData_info, parent:key})
          }
        })
    }
    if (key === product_data) {
      if(inspectData[key].product_info){
        let productInfo = inspectData[key].product_info;
        {Object.entries(mapToProductDetials).map(([label, key]) => {
          const condition = productInfo.some(item => item.name === label)
          if(!condition &&  inspectData.hasOwnProperty(key)){
            const pro_details = {name: label, value: inspectData[key]};
            productInfo = [...productInfo,pro_details]
          }
        })
        let UpdatedProductInfo = excludingEmptyValues(productInfo)
        productDetails = { header: ProductDetails, conetent: UpdatedProductInfo,parent:key };
      }
    }
      if(inspectData[key].location_attributes){
        if(inspectData[key].location_attributes.length != 0){
          let usi = inspectData[key].location_attributes[0];
          let uiisiDetails_info = excludingEmptyValues(usi)
          UiiSiiDetails = { header: usi.location_name, conetent: uiisiDetails_info ,parent:key }
        }
      }
      if(inspectData[key].functional_testing && inspectData[key].functional_testing.length>0){
        const arr = inspectData[key].functional_testing.map((el) => el.attributes)
        const lastItemInMap = arr[arr.length-1]
        let rows = lastItemInMap.length;
        let array = []
        for(let i=0;i<rows;i++){
          let items = lastItemInMap[i].length
          for(let j=0;j<items; j++) {
            array.push(lastItemInMap[i][j])
          }
        }
        let functional_testing_info = excludingEmptyValues(lastItemInMap)
          functionalTesting = {header: functionalTestingHeader,conetent:functional_testing_info,parent:key }
        
      }
      if(inspectData[key].visual_testing && inspectData[key].visual_testing.length>0){
        const arr = inspectData[key].visual_testing.map((el) => el.attributes)
        const lastItemInMap = arr[arr.length-1]
        let rows = lastItemInMap.length;
        let array = []
        for(let i=0;i<rows;i++){
          let items = lastItemInMap[i].length
          for(let j=0;j<items; j++) {
            array.push(lastItemInMap[i][j])
          }
        }
        let visualTesting_info = excludingEmptyValues(lastItemInMap)
        visualTesting = {header: visualTestingHeader,conetent:visualTesting_info,parent:key }
      }
      if(inspectData[key].final_qc && inspectData[key].final_qc.length>0){
        const arr = inspectData[key].final_qc.map((el) => el.attributes)
        const lastItemInMap = arr[arr.length-1]
        let rows = lastItemInMap.length;
        let array = []
        for(let i=0;i<rows;i++){
          let items = lastItemInMap[i].length
          for(let j=0;j<items; j++) {
            array.push(lastItemInMap[i][j])
          }
        }
        let final_qc_info = excludingEmptyValues(lastItemInMap)
        final_qc = {header: finalQcHeader,conetent:final_qc_info,parent:key }
      }
      

    }
    if (key === 'tp_attributes') {
      tpAttributes = { header: tp_attributes, conetent: inspectData[key],parent:key }
    }
    if(key === "transitInfo"){
      transitInformation = { header: transitInfo, conetent: inspectData[key][0],parent:key }
    }
   }
   catch(error){
    setHasError({
      error: true,
      message: error
    })
   }
  }

  const inspectArray = [
    pairing_info,
    productDetails,
    functionalTesting,
    visualTesting,
    final_qc,
    weight_validationStatus,
    purchaseOrderPacking,
    levelDetails,
    level8Details,
    childListDetails,
    UiiSiiDetails,
    pdi_inspect,
    dispatch,
    grn,
    ...traceData,
    grade_change,
    tp,
    tpAttributes,
    transitInformation,
  ];
  
  const inputChangedHandler = (e, fieldName) => {
    try {
      const updateElemetForm = e.target.value;
      setformValue(updateElemetForm);
      setShowInspectData(false)
      JSON.stringify('') === JSON.stringify(e.target.value) && 
      setIsShowClear(prevState => {
        return {
          ...prevState,
          isbulkIotInspect: false,
          istrackIot: false
        }
      })
      if(validator.fieldValid(`${fieldName}`)){
      }else{
        validator.showMessageFor(`${fieldName}`)
      }
    }catch (error) {
      setHasError({
        error: true,
        message: error
    })
    }
  }


  const inputChangedHandlerInspect = (e, fieldName) => {
    try {
      setInspectValue(e.target.value)
      setIsCollapse(false)
      JSON.stringify('') === JSON.stringify(e.target.value) && 
      setIsShowClear(prevState => {
        return {
          ...prevState,
          isIotInspect: false
        }
      })
      if(validator.fieldValid(`${fieldName}`)){
        
      }else{
        validator.showMessageFor(`${fieldName}`)
      }
    } catch(error){
      setHasError({
        error: true,
        message: error
    })
    }
  }

  const handleKeyDown = (placeholder, event) => {
    if (event.key === 'Enter') {
      open(placeholder, event.target.value)
    }
  };


  const clearInput = (e) => {
    setformValue("");
    setShowInspectData(false);
    setIsShowClear(prevState => {
      return {
        ...prevState,
        istrackIot: false
      }
    })
    setDisabledButton(prevState => {
      return {
        ...prevState,
        istrackIot: false
      }
    });
  };

  useEffect(() => {
      (async () => {
        try{
        if (pageLayoutData != globaldata.unDefined) {
          if (pageLayoutData[1] && pageLayoutData[1].hasOwnProperty('subComponentsItems')) {
            setshowFilter(false);
            let totalParams;
            let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
            if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
              const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
              totalParams = { ...totalParams, ...extraParameteres }
            }
            if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
              const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
              totalParams = { ...totalParams, ...firstTimeParameters }
            }
            totalParams = { ...totalParams, ...dynamicParameters }
            if (pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
              let paramsConverted = new URLSearchParams(totalParams);
              getURL = (`${getURL}?${paramsConverted.toString()}`);
              let responseData = await FetchAPI(getURL);
              handleNetworkErrors(responseData,setHasError);
              if (responseData.status == 200) {
                let responseDataJson = await responseData.json();
                if (responseDataJson.data.hasOwnProperty('addPermission'))
                  setAddButtonPermission(responseDataJson.data.addPermission)
                setFilteredCondition(responseDataJson.data.filterCondition)
                if (!isEmpty(responseDataJson.data.data)) {
                }
              }
  
            }
            else {
              let responseData = await PostAPI(getURL, totalParams);
              handleNetworkErrors(responseData,setHasError);
              if (responseData.status == 200) {
                let responseDataJson = responseData.data;
                if (!isEmpty(responseDataJson.data.data)) {
                  setAddButtonPermission(responseDataJson.data.addPermission)
                  setFilteredCondition(responseDataJson.data.filterCondition)
                }
              }
            }
          }
        }
        } catch (e) {
          setHasError({
            error: true,
            message: e
          })
        }
      })()
    
  }, [pageLayoutData])

  
  useEffect(() => {
      (async () => {
        try{
        let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
        const payload = {
          pageTypeID: 19,
          featureID: document.title.split(" ")[1] === globaldata.Assign ? 2 : 1,
          language : localStorage.getItem('i18nextLng') === 'en' ? 'languages.en' : 'languages.chi'
        };
        cookies.set('userData.featureId', 1, { path: '/' });
        if(globalLoadIndicator != "0" && globalLoadIndicator != "1"){
        await setGlobalLoadIndicator('1');
        let response = await PostAPI(url, payload);
        handleNetworkErrors(response,setHasError);
        await setFeatureBlueprint(response);
        await setGlobalLoadIndicator('2');
        }
        } catch (e) {
          setHasError({
            error: true,
            message: e
          })
        }
      })()
    }, [])
 
 

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData(globaldata.unDefined);
    }
  }, [globalLoadIndicator]);

  useEffect(() => {
    setInspectValue('')
  },[pageLayoutDataContext])


  async function exportPdf(e, url) {
    e.preventDefault();
    window.location.href = url;
  }

  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, [isCollapse, showInspectData])


  const getInspect = async (placeholder, inspectNumber) =>{
    try {
      const isEmptyInspect = JSON.stringify('') === JSON.stringify(inspectValue);
      setShowInspectLoadingSpinner(true)
      setDisabledButton(prevState => {
        return {
          ...prevState,
          isIotInspect: true
        }
      });
      if(isEmptyInspect){
      setShowInspectLoadingSpinner(false)
      setDisabledButton(prevState => {
        return {
          ...prevState,
          isIotInspect: false
        }
      });
      switch(cookies.get("customer_id")) {
        case '13':
        case '14':{
          swal({ title: `${t("alert.16-digit_numeric_data")}`, text: `${t('alert.inspectValue')}`, icon:  globaldata.warning, button: `${t("alerts.ok")}` })
        }
          break;
        case '15':{
          swal({ title: `${t("alert.16-digit_alpha-numeric")}`, text: `${t('alert.inspectValue')}`, icon:  globaldata.warning, button: `${t("alerts.ok")}` })
          break;
        }
        default:{
          swal({ title: `${t("alert.11-digit_alpha-numeric_message")}`, text: `${t('alert.inspectValue')}`, icon:  globaldata.warning, button: `${t("alerts.ok")}` })
        } 
        }
      }
      if(validator.fieldValid(`${placeholder}`) && JSON.stringify('') !== JSON.stringify(inspectValue)){
        setIsCollapse(true)
        setIsShowClear(prevState => {
          return {
            ...prevState,
            isIotInspect: true
          }
        })
        let requiredValues = {
          user_id: cookies.get(globaldata.userId),
          user_locationId: cookies.get(globaldata.userLocationId),
          eseal_id: inspectNumber,
          mfg_Id: cookies.get(globaldata.customerId),
        }
        let dataObject = {
          ...requiredValues,
        }
        const getURL = (pageLayoutData[0].inspectApiEndPoint) ? pageLayoutData[0].inspectApiEndPoint
          : 'not found';
        let getresponse = await PostAPI(getURL, dataObject);
        handleNetworkErrors(getresponse,setHasError);
        if(getresponse.data.data.Status == 0) {
          let text;
          const responsedata = getresponse.data?.data?.Message;
          if(JSON.stringify(responsedata) === JSON.stringify({})){
            text = `${t("alerts.something_went_wrong")}`
          }
          else if(typeof responsedata == 'object'){
            text = `${t("alerts.something_went_wrong")} Please re-inspect the serial number`
          }
          else{
            text = responsedata ?? `${t("alerts.something_went_wrong")}`
          }
          setDisabledButton(prevState => {
        return {
          ...prevState,
          isIotInspect: false
        }
      });
         swal({text,
              icon: "error",
              button:`${t("alerts.ok")}`
          });
          setShowInspectLoadingSpinner(false)
          setIsCollapse(false);
        }
        else{
        setDisabledButton(prevState => {
        return {
          ...prevState,
          isIotInspect: false
        }
      });
        setInspectData(getresponse.data.data.data)
        setShowInspectLoadingSpinner(false)
        }
      }else{
        setDisabledButton(prevState => {
        return {
          ...prevState,
          isIotInspect: false
        }
      });
        setShowInspectLoadingSpinner(false)
        validator.showMessageFor(`${placeholder}`);
      }
    }catch (error) {
      setHasError({
        error: true,
        message: error
    })
    }
  }


function inspectValidationRules() { 
  switch(cookies.get("customer_id")) {
  case '13':
  case '14':
  case '15':
  case '17':
    return 'required|max:16|regex:^[a-zA-Z0-9]{16}$';
  default:
    return 'required|max:11|regex:^[a-zA-Z0-9]{11}$';
  }
}

function inspectShowValidationMessages() { 
  switch(cookies.get("customer_id")) {
    case '13':
    case '14':
      return 'Invalid format. Please enter 16-character numeric values';
    case "15":
      return 'Invalid format. Please enter 16-character alphanumeric values';
    default:
      return 'Invalid format. Please enter 11-character alphanumeric values';
  }
}

  async function downloadBulkIotReport(e, fieldName) {
    try {
     let regex
     const str = formValue
     setDisabledButton(prevState => {
       return {
         ...prevState ,
         isbulkIotInspect: true
       }
     });
     if(str === undefined || JSON.stringify('') === JSON.stringify(str)){
     setDisabledButton(prevState => {
       return {
         ...prevState,
         isbulkIotInspect : false
       }
     });
       switch (cookies.get("customer_id")) {
         case '13':
         case '14':
         case '17':
           swal({
             title: `${t("alert.16-digit_numeric_message")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
           break;
         case '15':
           swal({
             title: `${t("alert.16-digit_alpha-numeric_message")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
           break;
         default:
           swal({
             title: `${t("alert.11-digit_alpha-numeric_message_bulk")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
       }
     }
     if (validator.fieldValid(`${fieldName}`)) {
       switch(cookies.get("customer_id")) {
         case '13':
         case '14':
         case '17': {
           regex = new RegExp('^((\\d{16})[,;])*(\\d{16})$', 'gi')
           break;
         }
           
         case '15':{
           regex = new RegExp('^(([a-zA-Z\\d]{16})[,;])*(?:[a-zA-Z\\d]{16})$', 'gi');
           break;
         }
         default:{
         regex = new RegExp('^(([a-zA-Z\\d]{11})[,;])*(?:[a-zA-Z\\d]{11})$', 'gi');
         } 
       }
     let val;
     if (val = regex.exec(str) === null) {
       setDisabledButton(prevState => {
         return {
           ...prevState,
           isbulkIotInspect : false
         }
       });
       switch (cookies.get("customer_id")) {
         case '13':
         case '14':
         case '17':
           swal({
             title: `${t("alert.16-digit_numeric_message")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
           break;
         case '15':
           swal({
             title: `${t("alert.16-digit_alpha-numeric_message")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
           break;
         default:
           swal({
             title: `${t("alert.11-digit_alpha-numeric_message_bulk")}`,
             text: `${t("alert.generateIotReport")}`,
             icon: globaldata.warning,
             button: `${t("alerts.ok")}`
           })
       }
     } else {
     e.preventDefault();
     setIsShowClear(prevState => {
       return {
         ...prevState,
         isbulkIotInspect: true
       }
     })
     let requiredValues = {
       user_id: cookies.get(globaldata.userId),
       customer_id: cookies.get(globaldata.customerId),
       email: localStorage.getItem(globaldata.email),
       language: language,
       id: formValue && formValue.replace(/\s+/g, '')
     }
     const getURL = (pageLayoutData[0].exportApiEndPoint) ? pageLayoutData[0].exportApiEndPoint: 'not found';
     let newgetURL, getresponse, dataObject;
       let getresponseJson
       if (pageLayoutData[0].apiEndPointType === globaldata.GET) {
         const paramString = new URLSearchParams(requiredValues);
         newgetURL = (`${getURL}?${paramString.toString()}`);
         setIsLoader(true)
         getresponse = await FetchAPI(newgetURL);
         handleNetworkErrors(getresponse,setHasError);
         getresponseJson = await getresponse.json();
         setIsLoader(false)
         if(Object.hasOwn(getresponseJson.data,'data')){
           setDisabledButton(prevState => {
             return {
               ...prevState,
               isbulkIotInspect: false
             }
           });
           window.location.href = getresponseJson.data.data
         }else{
           if(getresponseJson.data.status === 409){
             setDisabledButton(prevState => {
               return {
                 ...prevState,
                 isbulkIotInspect: false
               }
             });
           setformValue("")
           swal(getresponseJson.data.message,{
             icon : "error",
             button: `${t("alerts.ok")}`
           })
         }
         else{
           setDisabledButton(prevState => {
             return {
               ...prevState,
               isbulkIotInspect : false
             }
           });
           swal(`${t("alerts.something_went_wrong")}`, {
             icon: "error",
             timer: 1000,
             button: false
         });
         }
         }
       }
       else {
         getresponse = await PostAPI(getURL, requiredValues);
         handleNetworkErrors(getresponse,setHasError);
         setDisabledButton(prevState => {
           return {
             ...prevState,
             isbulkIotInspect : false
           }
         });
       }
     }
   } else{
     return 
   }
    }
    catch(error) {
     setHasError({
      error: true,
      message: error
    })
  }
  }



  async function open(placeholder) {
    getInspect(placeholder, arguments[1] ?? inspectValue)
  }

  const formHandler = async (event, placeholder) => {
   try{
     setShowTrackIOTInspectLoadingSpinner(true)
     setDisabledButton(prevState => {
       return {
         ...prevState,
         istrackIot: true
       }
     });
      if(formValue && formValue.length == 11) {
       if (validator.fieldValid(`${placeholder}`)) {
         setIsShowClear(prevState => {
           return {
             ...prevState,
             istrackIot: true
           }
         })
         let newgetURL = null;
         let totalParams;
         let URL = pageLayoutData[0].exportApiEndPoint
         let getURL = URL + `?${globaldata.id}=`+formValue;
         //  totalParams = {...totalParams, ...dynamicParameters}
         let paramsConverted = new URLSearchParams(totalParams);
         newgetURL = (`${getURL}?${paramsConverted.toString()}`);
         let responseData = await FetchAPI(getURL);
         handleNetworkErrors(responseData,setHasError);
         if(responseData.status === 200){
           let responseDataJson = await responseData.json();
           setDisabledButton(prevState => {
               return {
                 ...prevState,
                 istrackIot: false
               }
           });          
           setShowTrackIOTInspectLoadingSpinner(false)
           if(!isEmpty(responseDataJson.data)){
            if(responseDataJson.data?.message){
              swal(responseDataJson.data.message, {
                icon: "info",
                button:`${t("alerts.ok")}`
              });
           }else{
           setIotInspectData(responseDataJson.data.inspectdata)
           setShowInspectData(true); 
           }
           }
           else{
            swal({
                    text: `No details found against provided serial number ${formValue}`,
                    icon: "info",
                    button:`${t("alerts.ok")}`,
                })
           }
         }else{
           setDisabledButton(prevState => {
             return {
               ...prevState,
               istrackIot: false
             }
           });          
          setShowTrackIOTInspectLoadingSpinner(false)
         }
         } else{
           setDisabledButton(prevState => {
               return {
                   ...prevState,
                   istrackIot: false
               }
           });          
           setShowTrackIOTInspectLoadingSpinner(false)
           validator.showMessageFor(`${placeholder}`);
             //  setInspectData(getresponse.data.data.data)
         }
     }
     else{
     setShowTrackIOTInspectLoadingSpinner(false)
     setDisabledButton(prevState => {
       return {
         ...prevState,
         istrackIot: false
       }
     });
     swal({title:`${t("alert.11-digit_alpha-numeric_iot_message")}`, 
         text:`${t("alert.inspectData")}`, 
         icon: globaldata.warning, 
         button:`${t("alerts.ok")}`})
     }
    }catch(error){
      setHasError({
        error: true,
        message: error
      })
    }
  }
  
  async function clearinspectInput(e) {
    setInspectData()
    setIsShowClear(prevState => {
      return {
        ...prevState,
        isIotInspect: false
      }
    })
    setInspectValue("")
  }

  async function clearbulkInput(e) {
    setformValue("")
    setIsShowClear(prevState => {
      return {
        ...prevState,
        isbulkIotInspect: false
      }
    })
  }

 async function SearchForInspect(event,inspect){
  setShowInspectLoadingSpinner(true)
    setInspectValue(inspect)
    getInspect('IOT',inspect)
  }

  function titleCase(str,el) {
    if(str !== 'EAN' && str !== 'PO Number'){
      return str.replace(/\w\S*/g, function(t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); 
       })
      }else{
        return str
       }
}


let removeObjectProperties = function(obj) {
  const excludedProps = ['source_address','source_loc_type','src_lat','src_long',
  'dest_address','dest_lat','dest_loc_type','dest_long','status',
  'time','slocid','dlocid','tp','is_grade'];
  try{
   for(var i = 0; i < excludedProps.length; i++) {
       if(obj.hasOwnProperty(excludedProps[i])) {
          delete obj[excludedProps[i]];
       }
    }
  }catch(error){
    setHasError({
      error: true,
      message: error
    })
  }
};

function assignUniqueId(obj) {
  const header = obj.header;
  let headerEntry = headerCounterArray.find(entry => entry.header === header);

  if (headerEntry) {
    headerEntry.count += 1;
  } else {
    headerEntry = { header, count: 1 };
    headerCounterArray.push(headerEntry);
  }
  return {
    ...obj,
    uniqueId: `${header}-${headerEntry.count}`
  };
}

  function buildAccordian(inspect, header, content,parent) {
    const obj = assignUniqueId(inspect);
   try{
    let contentData = [];
    let extra;
    let dispatchDetails;
    let childList

    
    if(header === ChildInfo){
      childList = content
    }

    if (header === 'TP') {
      contentData.push({ key: 'TP ID', value: content })
    }

    if(header === Weight_Validation_Status){
      extra = content.Date
      contentData.push({ key: 'Status', value: content.status === '1'? 'Pass' : 'Fail'})
    }

    if (header === Pairing_Info) {
      extra = content.Updated_Date ?? content.Created_Date
      let properties = Object.keys(content).reduce((custom, key) => {
        custom.push({ name: key, value: content[key] });
        const modifiedData = custom.filter(item => item.value !== null);
        return modifiedData;
      }, []);
      properties.forEach((e) => {
        if (e.name === "status") {
            e.value = e.value === 1 ? 'Pass' : 'Fail'; 
        }
      })
      properties.forEach((e) => {
        contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
      })
    }

    // if (header === 'Purchase Order Packing') {
    //   extra = content.time
    //   dispatchDetails = content.source
    // }
    if(parent === trace_info){
      extra = content.time

      if (header == Dispatch) {
        dispatchDetails = `${content.source} ${content.destination ? `-${content.destination}` : ''}`
      }
      else if(header === 'Grade Change'){
        delete content['status']
        const product_grade = content['is_grade']
        removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
            custom.push({ name: key, value: content[key]},{
              name: 'Product Grade', value: product_grade
            });
          return custom;
      }, []);
      properties.forEach((e) => {
        contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
      })
      }
      else if (header == Customer_registration || header == Warranty_return || header == Warranty_return_update){
        removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
            custom.push({ name: key, value: content[key]});
          return custom;
      }, []);
      properties.forEach((e) => {
        contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
      })
      }
      else if (header === 'Import Dispatch'){
        removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
            custom.push({ name: key, value: content[key]});
          return custom;
      }, []);
          properties.forEach((e) => {
            contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
          })
      }
      else if (header === 'PDI Hold' || header === 'PDI Approved'){
        removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
            custom.push({ name: key, value: content[key]});
          return custom;
        }, []);
          properties.forEach((e) => {
            contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
          })
      }
      else if (header === 'GI STO' || header === 'GI REWORK' || header === 'GI SO'){
        removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
          custom.push({ name: key, value: content[key]});
        return custom;
    }, []);
    properties.forEach((e) => {
      contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
    })
      }
      else{
        dispatchDetails = content.source
      }
    
    }

    if( header === content.location_name){
      if(Object.hasOwn(content,'attributes')){
      let modifiedContent = content.attributes.filter((el) => el.name !== 'PO Number')
      modifiedContent.map(e => {
        contentData.push({ key: e.name, value: e.value })
      })
    }
    }
    if( header === functionalTestingHeader|| header===visualTestingHeader || header===finalQcHeader){
      if (Array.isArray(content)) {
      content.map(e => {
        contentData.push({ key: e.name, value: e.value, time_stamp: e[Object.keys(e)[2]]})
      })
    }
    }

    if(header === transitInfo){
      removeObjectProperties(content)
        let properties = Object.keys(content).reduce((custom, key) => {
            custom.push({ name: key, value: content[key]});
          return custom;
      }, []);
          properties.forEach((e) => {
            contentData.push({ key: e.name.replace(/_/g, ' '), value: e.value })
          })
      }
    
    if (header === Level1_Details || header === ProductDetails || header === Level8_Details || header === tp_attributes) {
      content.map(e => {
        if (e.name === "batch_no"){
          e.name="Batch No" 
        } 
        if (e.name==="ean"){
          e.name="EAN"
        }  
        if (e.name==="mrp"){
          e.name="MRP"
        }
        if (e.name==="level Id"){
          e.name="Level Id"
        }

        if(e.name !='Title'){
          contentData.push({ key: e.name, value: e.value })
          }   
        // contentData.push({ key: e.name, value: e.value })
        
      })
      
    }

    return (
    <Panel header={t(header)} key={obj.uniqueId} extra={extra} >
       { childList !=null? childList.map(e=>{ 
         return <div >
          <p style={{color:"blue",width:"100px",cursor: "pointer"}} onClick={(event)=>SearchForInspect(event,e)}>{e}</p>
         </div>
        }):
        
        dispatchDetails != null?
        dispatchDetails:contentData.map((e) => <div>
          <Row>
            <Col md="4" className="inspect-left">
              <p> {titleCase(e.key)}</p>
            </Col>
            <Col md="5" className="inspect-right" >
              : { e.key==="Level Id"
              ?<p className="child_SearchIot" style={{cursor: "pointer"}} onClick={(event)=>SearchForInspect(event,e.value)} >{e.value }</p>
              : <p>{e.value}</p>}
              </Col>
                <Col md="3" className="inspect-timestamp">
                  <p >{e.time_stamp}</p>
            </Col>
          </Row>  
          
        </div>)}
      </Panel>
    )
    }catch(error){
      setHasError({
        error: true,
        message: error
      })
    }
  }

  return (
    (pageLayoutData != globaldata.unDefined) ?
      <div className="content" id="pdfcontent">
        <Grid fluid>
          <Card style={{ fontSize: '12px'}}
            title={(pageLayoutData[1]) ? t(pageLayoutData[1].title1) : ''}
            title2={(pageLayoutData[1]) ? t(pageLayoutData[1].title2) : ''}
            footer={true}
            content={
              <div className="inspect_grid-container" style={{ marginLeft: "20px", marginBottom:"30px" }}>
                {formElementsArray.map((formElement, index) => (
                  <div className="grid-item" key={index}>
                    {formElement.config.elementType === "input" ? (
                      <div className="grid-item-inner">
                        <label className="Label" htmlFor="">
                          {formElement.config.elementConfig.label}
                        </label>
                        <input
                          className="form-control"
                          type="search"
                          value={inspectValue}
                          onKeyDown={(e) => handleKeyDown(`${t(formElement.config.elementConfig.placeholder)}`, e)}
                          placeholder={t(formElement.config.elementConfig.placeholder)}
                          onChange={(e) => inputChangedHandlerInspect(e, `${t(formElement.config.elementConfig.placeholder)}`)}
                          onBlur={() => validator.showMessageFor('inputValue')}
                        />
                        <span style={{ color: 'red' }}>
                          {JSON.stringify('') !== JSON.stringify(inspectValue) &&
                            validator.message(
                              `${t(formElement.config.elementConfig.placeholder)}`,
                              inspectValue,
                              inspectValidationRules(),
                              {
                                messages: {
                                  required: 'The IOT inspect field is required.',
                                  regex: inspectShowValidationMessages(),
                                },
                              }
                            )}
                        </span>
                        <div className="inspect_button-container">
                          <ButtonField
                            color="info"
                            disabled={disabledButton.isIotInspect}
                            submit={() => open(`${t(formElement.config.elementConfig.placeholder)}`)}
                            BName={t(pageLayoutData[0].exportButtonName1)}
                          />
                          {isShowClear.isIotInspect && (
                            <ButtonField
                              color="danger"
                              key="ModalCLRBTN"
                              submit={(e) => clearinspectInput(e)}
                              BName={t("clear")}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="textarea-container">
                        <label className="Label" htmlFor="">
                          {formElement.config.elementConfig.label}
                        </label>
                        <textarea
                          style={{ resize: 'both', maxWidth: '800px', width: '100%', boxSizing: 'border-box' }}
                          rows="2"
                          cols="35"
                          className="form-control"
                          value={formValue}
                          placeholder={formElement.config.elementConfig.placeholder}
                          onChange={(e) => inputChangedHandler(e, `${t(formElement.config.elementConfig.placeholder)}`)}
                        />
                        <span style={{ color: 'red' }}>
                          {JSON.stringify('') !== JSON.stringify(formValue) &&
                            validator.message(
                              t(formElement.config.elementConfig.placeholder),
                              formValue,
                              'required'
                            )}
                        </span>
                        <div className="inspect_button-container">
                          <ButtonField
                            disabled={disabledButton.isbulkIotInspect}
                            color="info"
                            submit={(e) => downloadBulkIotReport(e, t(formElement.config.elementConfig.placeholder))}
                            BName={t(pageLayoutData[0].exportButtonName)}
                          />
                          {isShowClear.isbulkIotInspect && (
                            <ButtonField
                              color="danger"
                              key="ModalCLRBTN"
                              submit={(e) => clearbulkInput(e)}
                              BName={t('clear')}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {document.title.split(" ").slice(-2).join('-') == "Assign-Inspect" && (
                  <div className="grid-item">
                  <div className="track-iot-container">
                    <label className="Label" htmlFor="textInput">{t("Track IOT's")}</label>
                    <textarea
                      style={{ resize: 'both', maxWidth: '800px', width: '100%', boxSizing: 'border-box' }}
                      rows="2"
                      cols="35"
                      className="form-control"
                      value={formValue}
                      placeholder={t("IOT's")}
                      onChange={(e) => inputChangedHandler(e, `${t("IOT's")}`)}
                    />
                    <span style={{ color: 'red' }}>
                      {JSON.stringify('') !== JSON.stringify(formValue) &&
                        validator.message(
                          t("IOT's"),
                          formValue,
                          inspectValidationRules(),
                          {
                            messages: {
                              required: "The Track IOT's inspect field is required.",
                              regex: inspectShowValidationMessages(),
                            },
                          }
                        )}
                    </span>
                    <div className="inspect_button-container">
                      <ButtonField
                        color="info"
                        disabled={disabledButton.istrackIot}
                        submit={(e) => formHandler(e, t("IOT's"))}
                        BName={pageLayoutData[0].exportButtonName}/>
                      {isShowClear.istrackIot && (
                        <ButtonField
                          color="danger"
                          key="ModalCLRBTN"
                          submit={(e) => clearInput(e)}
                          BName={t("clear")}
                        />
                      )}
                    </div>
                  </div>
                  </div>
                )} 

                <div className="grid-item-full">
                  {showTrackIOTInspectLoadingSpinner ? (
                    <div className="text-center"><LoadingSpinner /></div>
                  ) : (
                    showInspectData && (
                      <form key="ModalForm">
                        <div className="grid-inspect-data">
                          {Object.entries(iotInspectData).map(([prop, val]) => {
                            const label = prop.replace(/_/g, ' ');
                            const value = prop === 'date' ? moment(iotInspectData.date).format('YYYY-MM-DD HH:mm:ss') : val;
                            return (
                              <div className="grid-inspect-item" key={prop}>
                                <label className="Label">{label}</label>
                                <input type="text" className="form-control" readOnly="readOnly" value={value} />
                              </div>
                            );
                          })}
                        </div>
                      </form>
                    )
                  )}
                </div>
            </div>
            }
          >
          </Card>

        {showInspectLoadingSpinner?  <Grid fluid>
          <div className="text-center"><LoadingSpinner /></div>
        </Grid> : inspectData && Object.keys(inspectData)?.length > 0 ?
          <div className="pannel-hight">
           {isCollapse && <Collapse onChange={onChange}>
            {inspectArray.map(inspect => {
              if (inspect && Object.keys(inspect).length !== 0){
                return buildAccordian(inspect, inspect.header, inspect.conetent,inspect.parent,setIsCollapse)
              }
            })}
            </Collapse>}
          </div> : ''
        }
        </Grid>

        {isLoader && <div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div> }
      </div>
      : <div className="content">
        <Grid fluid>
          <div className="text-center"><LoadingSpinner /></div>
        </Grid>
      </div>
  );
}

export default Role;

